import { render, staticRenderFns } from "./addSupervisorItem.vue?vue&type=template&id=5717b186&"
import script from "./addSupervisorItem.vue?vue&type=script&lang=js&"
export * from "./addSupervisorItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports